module.exports = __webpack_public_path__ + "img/circle.723cd1b6.png";